import { memo, useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import Filters from "components/Filters";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersSplit from "components/Filters/Split";
import { SavedFilterView } from "components/Filters/types";
import { AnalyticsPageContext } from "hooks/useAnalytics/pages/context";

import {
  FILTER_TYPE,
  FILTERS_ORDER_SETTINGS_KEY,
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
} from "../constants";
import { SEARCH_CONTEXTS_SUGGESTIONS_DICTIONARY } from "./constants";
import useContextsFilters from "./useContextsFilters";
import useContextsStore from "../useContextsStore";

type ContextsFiltersLayoutProps = {
  children: React.ReactNode;
  currentSavedView?: SavedFilterView;
  setCurrentSavedView: (view?: SavedFilterView) => unknown;
  titleId?: string;
};

const ContextsFiltersLayout = ({
  children,
  currentSavedView,
  setCurrentSavedView,
  titleId,
}: ContextsFiltersLayoutProps) => {
  const { filters, filtersMap, loading, itemsCount, sortOptions, refreshSuggestions } =
    useContextsFilters();

  const { setAllItemsQty } = useContextsStore(
    useShallow((state) => ({
      setAllItemsQty: state.setAllItemsQty,
    }))
  );

  useEffect(() => {
    setAllItemsQty(itemsCount);
  }, [itemsCount, setAllItemsQty]);

  return (
    <Filters
      filters={filters}
      filtersItemsOptionsMap={filtersMap}
      filtersLoading={loading}
      sortOptions={sortOptions}
      initialSortOption={INITIAL_SORT_OPTION}
      initialSortDirection={INITIAL_SORT_DIRECTION}
      pollActiveSections={refreshSuggestions}
      filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
      filtersDictionary={SEARCH_CONTEXTS_SUGGESTIONS_DICTIONARY}
      filtersType={FILTER_TYPE}
      currentSavedView={currentSavedView}
      setCurrentSavedView={setCurrentSavedView}
    >
      <FiltersSplit>
        <FiltersSidebar analyticsPage={AnalyticsPageContext.ContextsList} />

        <FiltersContentWrapper titleId={titleId}>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  );
};

export default memo(ContextsFiltersLayout);
